module.exports = __webpack_public_path__ + "images/marketing/peeps/jake_werlin.jpg";